module.exports = __webpack_public_path__ + "static/media/4.858258f4.jpg";